<template>
  <div>
    <!-- <el-button type="primary" size="small" style="margin: 10px 5px" @click="SureUpload">确认上传</el-button>
    <p v-if="fileList.length > 0" style="margin: 5px 5px;color:#909399 ;">如果上传信息无误后,请点击确认上传后在进行下面操作</p> -->
    <el-upload ref="myUpload" action="#" :list-type="type" :auto-upload="false" :limit="limit" :file-list="filearr"
      :on-change="OnChangeUpload" :on-exceed="handleExceed" multiple :on-progress="onProgress" :disabled="Isdisabled"
      :class="{ disUoloadSty: noneBtnDealImg }"
      style="width: 95%;border: 2px solid #DCDFE6;padding: 15px 5px 10px;min-width: 165px;" :apiType="apiType"
      :on-remove="handleRemove">
      <el-button v-if="type == 'text'" size="small" type="primary">点击上传</el-button>
      <i slot="default" class="el-icon-plus" v-else></i>

      <div slot="file" slot-scope="{file}" style="width: 100%;height: 100%;" v-if="type != 'text'">
        <el-image class="el-upload-list__item-thumbnail" :src="file.url" alt="" fit="fill"
          style="width: 100%;height: 100%;" :preview-src-list="scrList"></el-image>
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
            <i class="el-icon-zoom-in"></i>
          </span>
          <!-- <span v-if="!disableds" class="el-upload-list__item-delete" @click="handleDownload(file)">
            <i class="el-icon-download"></i>
          </span> -->
          <span v-if="!disableds" class="el-upload-list__item-delete" @click="handleRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>

      </div>
      <div style="width: 600px;" v-if="type == 'text' && fileList.length > 0">
        <div v-for="(file, index) in fileList">
          <el-button type="text" style="margin-left: 35px;display: inline-block;color: red;">
            {{ file.name }}
          </el-button>
          <el-button type="text" style="margin-left: 35px;display: inline-block;"
            @click.capture.stop="handleRemove(file)" v-if="file.name != ''">
            删除
          </el-button>
        </div>

      </div>
    </el-upload>

    <!-- <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt=""> -->
    <el-image ref="scrImg" id="scrimg" :src="dialogImageUrl" alt="" fit="fill" style="width: 100%;height: 0;"
      :preview-src-list="scrList"></el-image>
    <!-- </el-dialog> -->
  </div>
</template>

<script>

import myhttp from '../../utils/myhttp';
import qs from 'qs';
import axios from 'axios';
import COS from 'cos-js-sdk-v5';
const W = window, getOwn = A.getOwn;
const $Url = '/opportunity/tx-cloud-file/getPolicyTxCloudOpportunity';
export default {
  name: 'myUpload',
  components: {

  },
  props: {
    apiType: {
      default: "img"

    },
    filearr: {
      type: Array,
    },
    limit: {
      type: Number,
      default: 1

    },
    type: {
      type: String,
      default: "picture-card",
    },
  },
  data() {
    return {
      theFileList: [],
      loadingtext: '上传中...',
      maxLength: 0,
      loadings: '',
      dialogVisible: false,
      dialogImageUrl: '',
      noneBtnDealImg: false,
      Isdisabled: false,
      disableds: false,
      accessoryList: [],
      fileList: [],
      scrList: [],
    }
  },
  watch: {
    filearr: {
      handler(n, v) {
        // n.forEach((item,index)=>{
        //   const s ={
        //     name:item,
        //     uid:index,
        //     url:item
        //   }
        //   this.fileList.push(s)
        // })


        this.fileList = n;
        if (this.fileList.length == this.limit) {
          this.Isdisabled = true;
          this.noneBtnDealImg = true;
        } else {
          this.Isdisabled = false;
          this.noneBtnDealImg = false;
        }
      },
      // 该回调将会在侦听开始之后被立即调用
      immediate: true,
      //该回调会在任何被侦听的对象的 property 改变时被调用，不论其被嵌套多深
      deep: true

    },
    fileList: {

      handler(n, v) {
        console.log('fileList', n);
        if (this.fileList.length == this.limit) {
          this.Isdisabled = true;
          this.noneBtnDealImg = true;
        } else {
          this.Isdisabled = false;
          this.noneBtnDealImg = false;
        }
      },

      immediate: true,
      //该回调会在任何被侦听的对象的 property 改变时被调用，不论其被嵌套多深
      deep: true
    }
  },

  created() { },
  methods: {
    getTenXunCloudKey() {
      return new Promise((resolve, reject) => {
        W.App.$post($Url, null, null).then(function (res) {
          if (res.data.data) {
            resolve(res.data.data)
          }
        })
      })
    },
    // 秘钥初始化
    getCosInIt() {
      const cos = new COS({
        SimpleUploadMethod: 'putObject', // 强烈建议，高级上传、批量上传内部对小文件做简单上传时使用putObject,sdk版本至少需要v1.3.0
        getAuthorization: async (options, callback) => {
          // 初始化时不会调用，只有调用 cos 方法（例如 cos.putObject）时才会进入
          // 异步获取临时密钥
          // 服务端 JS 示例：https://github.com/tencentyun/cos-js-sdk-v5/blob/master/server/
          // 服务端其他语言参考 COS STS SDK ：https://github.com/tencentyun/qcloud-cos-sts-sdk
          // STS 详细文档指引看：https://cloud.tencent.com/document/product/436/14048
          const data = await this.getTenXunCloudKey();
          callback({
            TmpSecretId: data.tmpSecretId,
            TmpSecretKey: data.tmpSecretKey,
            // v1.2.0之前版本的 SDK 使用 XCosSecurityToken 而不是 SecurityToken
            SecurityToken: data.sessionToken,
            // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
            StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
            ExpiredTime: data.expiredTime, // 时间戳，单位秒，如：1580000900
          });
        }
      });
      return cos
    },
    // 腾讯云对象存储上传
    async TenXunCloudUploadFile(file) {
      var that = this
      return new Promise(async (resolve, reject) => {
        const key = await this.getTenXunCloudKey()
        const cos = this.getCosInIt()
        const fileName = file.uid + file.lastModified
        const fileType = file.name.split('.')

        cos.uploadFile({
          Bucket: key.bucket, // 填写自己的 bucket，必须字段
          Region: key.region, // 存储桶所在地域，必须字段
          Key: key.filePath + '/' + fileName + '.' + fileType[fileType.length - 1], // 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段
          Body: file,
          /* v1.4.3之前的版本必须，v1.4.3及以后的版本非必须 */
          SliceSize: 1024 * 1024 * 5, // 触发分块上传的阈值，超过5MB 使用分块上传，小于5MB使用简单上传。可自行设置
          onProgress: function (progressData) {
            console.log('上传进度：', progressData);
            const loadingtext = '上传中...' + progressData.percent * 100 + '%';
            if (that.loadings) {
              that.loadings.setText(loadingtext);
            } else {
              // 首次创建loading实例
              that.loadings = that.$loading({
                lock: true,
                text: loadingtext,
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
              });
            }
            // that.loadings.close()
            console.log(that.loadingtext);

          },
        }).then(data => {
          console.log('上传成功', data);
          const url = key.baseHttp + key.filePath + '/' + fileName + '.' + fileType[fileType.length - 1]
          resolve(url)
        }).catch(err => {
          console.log('上传出错', err);
        });
      })
    },
    fileAllRemove() {

      this.$nextTick(() => {
        this.$refs.myUpload.clearFiles()
        this.Isdisabled = false;
        this.noneBtnDealImg = false;
        this.fileList = []
        console.log(this.fileList);
      })

    },
    openLoading() {
      //loading请求等待
      var that = this
      that.loadings = that.$loading({
        lock: true,
        text: that.loadingtext,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    async SureUpload() {
      const data = [];
      const NameArr = [];
      let Data = new FormData();
      this.accessoryList.forEach((item, index) => {
        if (item.raw && !item.isUpload) {
          let Datas = new FormData();
          // Data.append("file", item.raw);
          //     data.push( myhttp.postFileUsers("/opportunity/tx-cloud-file/uploadFileToTxCloudOpportunity",Data));
          data.push(this.TenXunCloudUploadFile(item.raw));
          item.isUpload = true;
        }
      });
      this.openLoading()
      const res = await Promise.all(data);
      console.log(res);
      const url = [];
      // if (this.type == 'text') {
      //   res.forEach((item, index) => {
      //     const s = {
      //       name: NameArr[index],
      //       url: item.data
      //     }
      //     url.push(s)
      //   })
      // } else {
      res.forEach((item, index) => {
        const s = item.data ? item.data : item
        url.push(s)
      })
      // }
      console.log("url====", url);
      this.loadings.close()
      this.$emit('fileChange', url)

    },

    uploadbf(file) {
      console.log(file);
    },
    onProgress(event, file, fileList) {
      console.log(event, file, fileList);
    },
    // 检验文件
    uploadFilesVerification(file, fileList) {
      let existFile = fileList.slice(0, fileList.length - 1).find((f) => f.name === file.name);
      if (existFile) {
        this.$message.error('当前文件已经存在!');
        fileList.pop();
        return
      }
      this.accessoryList = fileList;
      this.fileList = fileList;
      this.SureUpload(file, fileList)
      console.log(fileList, this.fileList,);
    },
    async OnChangeUpload(file, fileList) {
      this.maxLength = 0;
      let length = fileList.length;
      this.maxLength = Math.max(length, this.maxLength);
      const theFile = file;
      theFile.isUpload = false;
      this.theFileList.push(theFile);
      setTimeout(() => {
        if (length === this.maxLength) {
          console.log(this.maxLength);
          this.uploadFilesVerification(file, this.theFileList)
        }
      }, 100)
    },
    submitUpload() {

    },
    handleRemove(file) {
      console.log(file);
      const url = this.fileList.findIndex(item => item.url === file.url)
      const uid = this.fileList.findIndex(item => item.uid === file.uid)

      if (url) {
        console.log('2');
        this.fileList.splice(url, 1);
        this.theFileList.splice(url, 1);
        this.$emit('removeAfter', file.url)
        return
      } else {
        console.log('1');
        this.fileList.splice(uid, 1);
        this.theFileList.splice(uid, 1);
        this.$emit('removeAfter', file.url)
        return
      }
    },
    handlePictureCardPreview(file) {
      console.log(this.$refs.scrImg);
      this.dialogImageUrl = file.url;
      this.fileList.forEach(item => {
        this.scrList.push(item.url)
      })
      this.$refs.scrImg.clickHandler()
    },
    handleDownload(file) {
      console.log(file);
    },
    //限制上传附件
    handleExceed(files, fileList) {
      console.log(files);
      const val = this.limit - this.fileList.length
      if (val < files.length) {
        this.$message.warning(`当前限制选择 ${this.limit} 个文件，一共选择了 ${files.length + this.fileList.length} 个文件`)
        return
      }
      const size = files.size / 1024 / 1024;
      if (files.length > this.limit) {
        this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件`)
        return
      }
      if (size > 5) {
        this.$message.warning("文件大小不得超过5M");
        return;
      }

    },

  }
}
</script>

<style scoped>
.disUoloadSty /deep/ .el-upload--picture-card {
  display: none;
  /* 上传按钮隐藏 */
}
</style>



// WEBPACK FOOTER //
// src/components/myUpload/my-upload.vue